import { CheckmarkIcon } from '@chegg-ui/theme'
import media from '@src/styled/media'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  box-sizing: border-box;
  background-color: #f5f5f5;
  flex-direction: column;
  width: 100%;
  align-items: center;
`

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 840px;
  padding: 16px 0;

  ${media.phone`
    padding: 40px 4px 40px 4px; 
  `};
`

export const Title = styled.h1`
  font-size: 34px;
  text-align: center;
  margin-bottom: 32px;
  margin-top: 0;
`

/**
 * This basically is just here to fix flexbox alignment issues
 */
export const Spacer = styled.div`
  flex: 1;
  border: 1px solid transparent;
  padding: 0 8px;
  ${media.phone`
    padding: 2px;
  `};
`

export const ProductName = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;

  flex: 1;
  font-weight: 700;
  font-size: 20px;
  text-align: center;

  & + & {
    margin-left: 8px;

    ${media.phone`
      margin-left: 0;
    `};
  }

  ${media.phone`
    font-size: 12px;
    padding: 0px 3px;
  `};
`

export const ProductNames = styled.div`
  display: flex;
  margin-bottom: 8px;
`

export const Products = styled.div`
  width: 100%;
`

export const FeatureWrapper = styled.div<{ recommended?: boolean }>`
  display: flex;
  flex-direction: column;

  flex: 1;
  padding: 0px 8px;

  background-color: white;
  font-size: 16px;
  font-weight: 500;

  border-left: 1px solid rgba(153, 153, 153, 0.5);
  border-right: 1px solid rgba(153, 153, 153, 0.5);

  & + & {
    margin-left: 8px;

    ${media.phone`
      margin-left: 1px;
    `};
  }

  *:first-child > & {
    border-top: 1px solid rgba(153, 153, 153, 0.5);
    border-radius: 8px 8px 0 0;

    ${({ recommended }) => recommended && `border-top: 2px solid rgba(153,153,153,0.8);`}
  }

  *:last-child > &:first-child {
    border-bottom: 1px solid rgba(153, 153, 153, 0.5);
    border-radius: 0 0 8px 8px;
  }

  ${({ recommended }) =>
    recommended &&
    `
    background-color: #eaf8f8;
    border-left: 2px solid rgba(153,153,153,0.8);
    border-right: 2px solid rgba(153,153,153,0.8);
  `}

  ${media.phone`
    font-size: 12px;
    padding: 0px 4px;

    *:last-child > & {
      border-bottom: 1px solid rgba(153, 153, 153, 0.5);
      border-radius: 0 0 8px 8px;

      ${(props: { recommended: boolean }) =>
        props.recommended && `border-bottom: 2px solid rgba(153,153,153,0.8);`}
    }
  `};
`

export const FeatureRow = styled.div`
  display: flex;
  width: 100%;
`

export const Feature = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 1;
  padding: 16px 0;
  text-align: center;

  ${FeatureRow} & {
    border-bottom: 1px solid rgba(153, 153, 153, 0.5);
  }

  ${FeatureRow}:last-child ${FeatureWrapper}:first-child & {
    border-bottom: none;
  }

  ${media.phone`
    ${FeatureRow}:last-child & {
      border-bottom: none;
    }
  `};
`

export const Features = styled.div`
  width: 100%;
`

export const Check = styled(CheckmarkIcon)`
  color: rgb(34, 157, 158);
`

export const PricesAndActions = styled.div`
  width: 100%;
`

export const Price = styled.div<{ recommended?: boolean }>`
  display: flex;
  background-color: white;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 20px;
  line-break: anywhere;

  flex: 1;
  padding: 16px 8px;
  margin-left: 8px;
  text-align: center;

  border-left: 1px solid rgba(153, 153, 153, 0.5);
  border-right: 1px solid rgba(153, 153, 153, 0.5);

  ${({ recommended }) =>
    recommended &&
    `
    background-color: #eaf8f8;
    border-left: 2px solid rgba(153,153,153,0.8);
    border-right: 2px solid rgba(153,153,153,0.8);
  `}

  ${media.phone`
      font-size: 14px;
      background-color: inherit;
      border: none;
      padding: 8px 0;
      margin-left: 1px;
  `};
`

export const Prices = styled.div`
  display: flex;
`

export const Action = styled.div<{ recommended?: boolean }>`
  display: flex;
  background-color: white;
  align-items: center;
  justify-content: center;

  flex: 1;

  padding: 8px;
  margin-left: 8px;

  border-left: 1px solid rgba(153, 153, 153, 0.5);
  border-right: 1px solid rgba(153, 153, 153, 0.5);
  border-bottom: 1px solid rgba(153, 153, 153, 0.5);
  border-radius: 0 0 8px 8px;

  ${({ recommended }) =>
    recommended &&
    `
  background-color: #eaf8f8;
  border-left: 2px solid rgba(153,153,153,0.8);
  border-right: 2px solid rgba(153,153,153,0.8);
  border-bottom: 2px solid rgba(153,153,153,0.8);
  `}

  ${media.phone`
    background-color: inherit;
    border: none;
    margin-left: 1px;
    padding: 2px;
  `};
`

export const Actions = styled.div`
  display: flex;
`

export const Link = styled.a<{ recommended?: boolean; current?: boolean }>`
  flex: 1;

  text-decoration: none;
  font-weight: 700;
  font-size: 20px;
  padding: 12px 6px;
  background-color: white;
  color: rgb(235, 113, 0);
  text-align: center;
  border-radius: 8px;
  border-width: 2px;
  border-style: solid;
  border-color: rgb(235, 113, 0);
  cursor: pointer;

  ${({ recommended }) =>
    recommended &&
    `
      background-color: rgb(235, 113, 0);
      color: white;
    `}

  ${({ current }) =>
    current &&
    `
      background-color: white;
      color: #999999;
      border-color: #999999;
      pointer-events: none;
      cursor: default;
    `}

  ${media.phone`
      font-size: 14px;
  `};
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 16px;
`

export const TermsAndConditions = styled.a`
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  font-weight: 700;
  color: #229d9e;
`



// WEBPACK FOOTER //
// ./src/components/PricingTable/styled.ts